module.exports = __webpack_public_path__ + "static/media/3d_design.cf11ccdd.svg";